import type { MenuItem } from "@/layouts/default-layout/config/types";
import { PermissonEnum, ModuleEnum } from "~/constants/documentEnum";
import { UserTypeEnum } from "~/constants/enum";
const MainMenuConfig: Array<MenuItem> = [
    {
        pages: [
            {
                heading: "Trang tổng quan",
                route: "/",
                keenthemesIcon: "element-11",
                bootstrapIcon: "bi-app-indicator",
            },
            {
                heading: "Hồ sơ bảo lãnh",
                route: "/documents",
                keenthemesIcon: "document",
                bootstrapIcon: "bi-layers",
            },
        ],
    },
    {
        //heading: "Hệ thống",
        //route: "/apps",
        pages: [
            // {
            //   heading: "Hợp đồng",
            //   route: "/contract",
            //   keenthemesIcon: "document",
            //   bootstrapIcon: "bi-layers",
            //   module: ModuleEnum.Customer,
            //   userTypes: [UserTypeEnum.Company],
            // },
            {
                heading: "Hồ sơ gốc",
                route: "/original-document",
                keenthemesIcon: "tablet-book",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.OriginalDocument,
            },
            {
                heading: "Ca chưa giải quyết",
                route: "/document-pending",
                keenthemesIcon: "file-down",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.DocumentPending,
            },
            {
                heading: "Chat",
                route: "/chat",
                keenthemesIcon: "tablet-book",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.Chat,
            },
            {
                heading: "Yêu cầu thanh toán",
                route: "/payment-request",
                keenthemesIcon: "dollar",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.PaymentRequest,
                userTypes: [UserTypeEnum.Facility, UserTypeEnum.Company],
            },
            {
                sectionTitle: "Yêu cầu thanh toán",
                route: "/payment-request",
                keenthemesIcon: "dollar",
                bootstrapIcon: "bi-layers",
                sub: [
                    {
                        heading: "Thanh toán cho CSYT",
                        route: "/payment-request/csyt",
                        module: ModuleEnum.PaymentRequest,
                        userTypes: [UserTypeEnum.MedCat],
                    },
                    {
                        heading: "Thanh toán của CTBH",
                        route: "/payment-request/ctbh",
                        module: ModuleEnum.PaymentRequest,
                        userTypes: [UserTypeEnum.MedCat],
                    },
                ],
            },
            {
                heading: "Hợp đồng",
                route: "/contract",
                keenthemesIcon: "more-2",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.Contract,
                userTypes: [UserTypeEnum.MedCat, UserTypeEnum.Company],
            },
            {
                heading: "Báo cáo nhân viên",
                route: "/user-report",
                keenthemesIcon: "badge",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.UserReport,
            },
            {
                heading: "Công ty bảo hiểm",
                route: "/company",
                keenthemesIcon: "safe-home",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.InsuranceCompany,
            },
            {
                heading: "Cơ sở y tế",
                route: "/facility",
                keenthemesIcon: "pulse",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.MedicalFacility,
            },
            {
                sectionTitle: "Quản lý danh mục",
                route: "/category",
                keenthemesIcon: "category",
                bootstrapIcon: "bi-printer",
                sub: [
                    {
                        heading: "Hình thức điều trị",
                        route: "/category/treatment-type",
                        module: ModuleEnum.Category,
                    },
                    {
                        heading: "Nhóm lý do",
                        route: "/category/disease-type",
                        module: ModuleEnum.Category,
                    },
                    {
                        heading: "Lý do từ chối",
                        route: "/category/reson-reject",
                        module: ModuleEnum.Category,
                    },
                    {
                        heading: "Loại giấy tờ",
                        route: "/category/document-type",
                        module: ModuleEnum.Category,
                    },
                ],
            },
            {
                sectionTitle: "Tài khoản",
                route: "/customers",
                keenthemesIcon: "profile-user",
                bootstrapIcon: "bi-printer",
                sub: [
                    {
                        heading: "Danh sách tài khoản",
                        route: "/account",
                        module: ModuleEnum.User,
                    },
                    {
                        heading: "Nhóm tài khoản",
                        route: "/role",
                        module: ModuleEnum.Role,
                    },
                ],
            },
            {
                heading: "Cấu hình hệ thống",
                route: "/system-config",
                keenthemesIcon: "setting-2",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.SystemConfig,
            },
            {
                heading: "Lịch sử hành động",
                route: "/activity-log",
                keenthemesIcon: "pulse",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.ActivityLog,
            },
        ],
    },
];

export default MainMenuConfig;

export function getAllChildModule() {
    const { $isPermission } = useNuxtApp();
    let allChildModule: Array<MenuItem> = [];
    MainMenuConfig.forEach((item) => {
        if (item.pages) {
            item.pages.forEach((page) => {
                if (page.sub) {
                    allChildModule = allChildModule.concat(
                        (page.sub ?? []).filter(
                            (c) => !c.module || $isPermission(c.module, PermissonEnum.Allow)
                        )
                    );
                }
            });
        }
        if (item.sub) {
            allChildModule = allChildModule.concat(
                (item.sub ?? []).filter(
                    (c) => !c.module || $isPermission(c.module, PermissonEnum.Allow)
                )
            );
        }
        if (!item.pages && !item.sub) {
            allChildModule.push(item);
        }
    });

    return allChildModule;
}
